import { useState, useEffect } from 'react';
import { AboutModel } from '../models/aboutModel';
import { useLanguage } from '../i18n/LanguageContext';

export function useAboutController() {
  const { selectedLanguage } = useLanguage();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(null);

    AboutModel.fetch(selectedLanguage)
      .then(d => {
        if (active) setData(d);
      })
      .catch(e => {
        if (active) setError(e);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [selectedLanguage]);

  return { data, loading, error };
}
